(function () {
  /* Shhirts variant tidy (2026-10-26)
   * Fit -> Color -> Size products: instead of striking out combinations that don't exist,
   * hide them. Fit always shows every value. Color shows only colors made in the chosen
   * fit AND size; Size shows only sizes made in the chosen fit AND color. Colors are
   * ordered dark -> light from the product metafield shhirts.color_order. If a change
   * leaves an impossible combination (e.g. switching fit), the nearest real one is picked.
   * On first load (no ?variant=), M is preselected so no color starts hidden. */
  var cfg = window.__SHH_TIDY__; if (!cfg) return;
  var SEL = 'variant-picker[handle="' + cfg.handle + '"]';
  var picker = document.querySelector(SEL);
  if (!picker) return;
  // The theme swaps the whole <variant-picker> on every change, so re-find it each pass
  // and watch the section that contains it.
  var root = picker.closest('[id^="shopify-section"]') || document.body;
  var ORDER = Array.isArray(cfg.colorOrder) ? cfg.colorOrder : [];
  var SIZE_PREF = ['M', 'L', 'S', 'XL', '2XL', 'XS', '3XL', '4XL', '5XL'];
  var variants = null, names = [], colorIdx = -1, sizeIdx = -1;
  var fixes = [], scheduled = false, firstRun = true;

  function inputsFor(pos) { return [].slice.call(picker.querySelectorAll('input[data-option-position="' + pos + '"]')); }
  function labelFor(input) { return picker.querySelector('label[for="' + CSS.escape(input.id) + '"]'); }
  function selected() {
    return names.map(function (_, i) {
      var c = picker.querySelector('input[data-option-position="' + (i + 1) + '"]:checked');
      return c ? c.getAttribute('data-value') : null;
    });
  }
  function exists(sel) {
    return variants.some(function (v) {
      return v.available && sel.every(function (val, i) { return val == null || v.options[i] === val; });
    });
  }
  function choose(pos, value) {
    var inp = inputsFor(pos).filter(function (i) { return i.getAttribute('data-value') === value; })[0];
    if (!inp || inp.checked) return false;
    var now = Date.now(); fixes = fixes.filter(function (t) { return now - t < 3000; });
    if (fixes.length >= 4) return false;            // never loop
    fixes.push(now); inp.click(); return true;
  }
  function rank(v) { var i = ORDER.indexOf(v); return i < 0 ? 999 : i; }

  function apply() {
    scheduled = false;
    picker = document.querySelector(SEL);
    if (!variants || !picker) return;
    var sel = selected();
    if (sel.some(function (s) { return s == null; })) return;

    // 1) first load: start on M so every color is visible
    if (firstRun) {
      firstRun = false;
      if (sizeIdx >= 0 && !/[?&]variant=/.test(location.search) && sel[sizeIdx] !== 'M') {
        var m = sel.slice(); m[sizeIdx] = 'M';
        if (exists(m) && choose(sizeIdx + 1, 'M')) return;
      }
    }
    // 2) impossible combination -> nearest real one (keep color if the fit has it, then size)
    if (!exists(sel)) {
      for (var k = 1; k < sel.length; k++) {
        var head = sel.slice(0, k + 1).concat(sel.slice(k + 1).map(function () { return null; }));
        if (exists(head)) continue;
        var vals = inputsFor(k + 1).map(function (i) { return i.getAttribute('data-value'); });
        if (k === colorIdx) vals.sort(function (a, b) { return rank(a) - rank(b); });
        if (k === sizeIdx) vals.sort(function (a, b) { return SIZE_PREF.indexOf(a) - SIZE_PREF.indexOf(b); });
        for (var j = 0; j < vals.length; j++) {
          var t = sel.slice(0, k).concat([vals[j]]).concat(sel.slice(k + 1).map(function () { return null; }));
          if (exists(t)) { if (choose(k + 1, vals[j])) return; break; }
        }
      }
    }
    // 3) hide what can't be bought with the other current choices; order colors
    for (var p = 1; p < names.length; p++) {
      inputsFor(p + 1).forEach(function (inp) {
        var val = inp.getAttribute('data-value'), probe = sel.slice(); probe[p] = val;
        var ok = exists(probe), lab = labelFor(inp);
        if (!lab) return;
        lab.style.display = ok ? '' : 'none';
        if (ok) lab.classList.remove('is-disabled');
        if (p === colorIdx) lab.style.order = rank(val);
      });
    }
    balance();
  }
  // 4) (2026-10-29, Dave) many colors: split the swatches into rows of about equal length (e.g. 8 + 7, not 11 + 4)
  //    by narrowing the swatch box. Only when the box wraps (on phones it can be a sideways-scrolling strip).
  function balance() {
    if (colorIdx < 0) return;
    var first = inputsFor(colorIdx + 1)[0]; if (!first) return;
    var box = first.parentElement; if (!box) return;
    box.style.maxWidth = '';
    var cs = getComputedStyle(box);
    if (cs.flexWrap !== 'wrap') return;
    var labs = inputsFor(colorIdx + 1).map(labelFor).filter(function (l) { return l && l.style.display !== 'none'; });
    if (labs.length < 2) return;
    var gap = parseFloat(cs.columnGap) || 0, w = 0;
    labs.forEach(function (l) { w = Math.max(w, l.getBoundingClientRect().width); });
    if (!w) return;
    var full = box.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var per = Math.max(1, Math.floor((full + gap) / (w + gap)));
    if (labs.length <= per) return;
    var rows = Math.ceil(labs.length / per), perRow = Math.ceil(labs.length / rows);
    box.style.maxWidth = Math.ceil(perRow * (w + gap) - gap + (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) + 1) + 'px';
  }
  window.addEventListener('resize', function () { clearTimeout(balance._t); balance._t = setTimeout(function () { picker = document.querySelector(SEL); if (picker) balance(); }, 150); });
  function schedule() { if (!scheduled) { scheduled = true; setTimeout(apply, 30); } }

  fetch('/products/' + cfg.handle + '.js').then(function (r) { return r.json(); }).then(function (prod) {
    variants = prod.variants;
    names = (prod.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    names.forEach(function (n, i) { if (/colou?r/i.test(n)) colorIdx = i; if (/size/i.test(n)) sizeIdx = i; });
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    root.addEventListener('change', schedule);
    apply();
  }).catch(function (e) { console.warn('[Shhirts] variant tidy:', e); });
})();
